import React, { FC } from 'react';
import { Route } from 'react-router';

import EquipmentsRepairEdit from '../components/equipments-repair/edit';
import { EquipmentsRepairs } from '../components/equipments-repair/index';

const EquipmentsRepairPage: FC = () => {
  return (
    <>
      <Route
        exact
        path="/equipments-repairs/edit/:id"
        component={EquipmentsRepairEdit}
      />
      <Route exact path="/equipments-repairs" component={EquipmentsRepairs} />
    </>
  );
};

export default EquipmentsRepairPage;
